import axios from 'axios';

export const postRequest = (params) => {

    return new Promise(function (resolve, reject) {
        axios.post('https://sinclairgore.decentgroup.co.uk/request.php', params)
            .then(function (response) {
                var result = JSON.parse(response.data.response.scriptResult);
                resolve(result);
            })
            .catch(function (error) {
                reject(error);
            });
    });

}

export const getDocumnetBlob = (url) => {

    return new Promise(function (resolve, reject) {
        axios.get(url, {
            headers: {
              "Content-Type": "application/octet-stream"
            },
            responseType: "blob"
          })
            .then(response => {
              resolve(response.data)
            })
            .catch(err => {
              reject(err);
            });
    });

}